<e-dialog
  [open]="target() !== null"
  (openChange)="onOpenChange($event)"
  [title]="text().title"
  [closeLabel]="text().close"
  size="md"
>
  <ng-template>
    <div class="chart-share">
      <p class="chart-share__intro">{{ text().intro }}</p>
      @if (text().noSaveNote) {
        <p class="chart-share__note" data-test-id="share-no-save-note">
          <i class="fas fa-circle-info" aria-hidden="true"></i>
          {{ text().noSaveNote }}
        </p>
      }
      <p class="chart-share__note">
        <i class="fas fa-user" aria-hidden="true"></i>
        {{ text().nameNote }}
      </p>

      @if (shareUrl(); as url) {
        <label class="chart-share__label" for="chart-share-link">{{ text().linkLabel }}</label>
        <div class="chart-share__link-row">
          <input
            id="chart-share-link"
            class="chart-share__link"
            type="text"
            readonly
            [value]="url"
            data-test-id="share-link"
            (focus)="$any($event.target).select()"
          />
          <button eBtn type="button" color="primary" icon="copy" data-test-id="share-copy" (click)="copy()">
            {{ text().copy }}
          </button>
        </div>
        <div class="chart-share__actions">
          <button eBtn type="button" color="danger" icon="link-slash" data-test-id="share-stop"
                  [disabled]="busy()" (click)="stop()">
            {{ text().stop }}
          </button>
        </div>
      } @else {
        <p class="chart-share__status">{{ text().notShared }}</p>
        <div class="chart-share__actions">
          <button eBtn type="button" color="primary" icon="share-nodes" data-test-id="share-create"
                  [disabled]="busy()" (click)="create()">
            {{ text().create }}
          </button>
        </div>
      }
    </div>
  </ng-template>
</e-dialog>
